<div class="label-wrapper">
  <label><i [style.color]="colors[0]" class="fa fa-circle"></i><span>Sent</span></label>
  <label *ngIf="false"><i [style.color]="colors[1]" class="fa fa-circle"></i>In progress</label>
  <label><i [style.color]="colors[2]" class="fa fa-circle"></i><span>Error</span></label>
</div>
<div class="bar-wrapper">
  <div *ngFor="let barGroup of barGroupData" class="bar-group" [attr.data-size]="barGroupData.length">
    <ng-template [ngIf]="barGroup.bars.length === 0 && barGroup.label">
      <div class="label-wrapper"><label>{{ barGroup.label }}</label></div>
    </ng-template>
    <ng-template [ngIf]="barGroup.bars.length === 1">
      <div
        class="bar out-of-1"
        placement="top"
        [ngbTooltip]="barGroup.bars[0].tooltip"
        [style.background-color]="barGroup.bars[0].color"
        [style.height]="barGroup.bars[0].height + 'px'"
        [style.width]="barGroup.bars[0].width + 'px'"
      ><div class="label-wrapper"><label>{{ barGroup.label }}</label></div></div>
    </ng-template>
    <ng-template [ngIf]="barGroup.bars.length === 2">
      <div
        class="bar out-of-2"
        placement="top"
        [ngbTooltip]="barGroup.bars[0].tooltip"
        [style.background-color]="barGroup.bars[0].color"
        [style.height]="barGroup.bars[0].height + 'px'"
        [style.width]="barGroup.bars[0].width + 'px'"
      ></div>
      <div class="label-wrapper"><label>{{ barGroup.label }}</label></div>
      <div
        class="bar out-of-2"
        placement="top"
        [ngbTooltip]="barGroup.bars[1].tooltip"
        [style.background-color]="barGroup.bars[1].color"
        [style.height]="barGroup.bars[1].height + 'px'"
        [style.width]="barGroup.bars[1].width + 'px'"
      ></div>
    </ng-template>
    <ng-template [ngIf]="barGroup.bars.length === 3">
      <div
        class="bar out-of-3"
        *ngFor="let bar of barGroup.bars; index as i"
        [style.background-color]="bar.color"
        [style.height]="bar.height + 'px'"
        [style.width]="bar.width + 'px'"
        placement="top"
        [ngbTooltip]="bar.tooltip"
      ><ng-template [ngIf]="i === 1">
        <div class="label-wrapper"><label>{{ barGroup.label }}</label></div>
      </ng-template></div>
    </ng-template>
  </div>
</div>
